import React, { Component } from 'react';
// import $ from 'jquery';
import commonUtil from '../../utils/commonUtil';

// import pdfUtil from '../../utils/PDFUtil';
// import ApplyCSS from '../ApplyCSS';
// const channel = commonUtil.getChannel();
const pageNameTableOrg = 'tableOrganizer';

class DownloadPDFWithoutPreview extends Component {
  constructor(props) {
    super(props);
    this.brandLogo = '';
    this.containerDom = null;

    this.pageHeight = 1336;
    this.currentHeight = 0;
    this.totalPageHeight = 1336;
    this.pageMargin = 50;
    this.heightToCheck = (this.totalPageHeight - this.pageMargin);
  }

  componentDidMount = () => {
    if (this.props.download) {
      // logic to split - start
      // reset the current top of control to reset the total height
      const downloadOffset = this.offset(document.querySelector('#downloadContainer'));
      this.setTotalHeight(this.totalPageHeight + downloadOffset.top);
      this.splitHTMLForPrintToPDF(document.querySelector('#divPrint'));
      // logic to split - end
    }
  }

  offset = (el) => {
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    // get the exact Y position of download control to get the start point of splitting
    let top = 0;
    let left = 0;
    let height = 0;
    let width = 0;
    let marginTop = 0;
    let marginBottom = 0;
    let paddingTop = 0;
    let paddingBottom = 0;
    let rect = null;
    let range = null;
    let computedStyle = null;
    let rects = [];

    if (el && el.nodeType) {
      if (el.nodeType === 3) {
        range = document.createRange();
        range.selectNodeContents(el);
        rects = range.getClientRects();
        if (rects.length > 0) {
          top = Math.ceil(rects[0].top + scrollTop);
          left = Math.ceil(rects[0].left + scrollLeft);
          height = Math.ceil(rects[rects.length - 1].top + rects[rects.length - 1].height);
          width = Math.ceil(rects[0].width);
        }
      } else if (el.nodeType === 1) {
        computedStyle = window.getComputedStyle(el);
        rect = (el.getBoundingClientRect) ? el.getBoundingClientRect() : null;

        top = Math.ceil(rect.top + scrollTop);
        left = Math.ceil(rect.left + scrollLeft);
        height = Math.ceil(rect.height);
        width = Math.ceil(rect.width);
        if (computedStyle) {
          paddingTop = computedStyle.getPropertyValue('padding-top').replace(/px|pt|em|%|mm|in|cm/gi, '');
          paddingBottom = computedStyle.getPropertyValue('padding-bottom').replace(/px|pt|em|%|mm|in|cm/gi, '');
          marginTop = computedStyle.getPropertyValue('margin-top').replace(/px|pt|em|%|mm|in|cm/gi, '');
          marginBottom = computedStyle.getPropertyValue('margin-bottom').replace(/px|pt|em|%|mm|in|cm/gi, '');

          paddingTop = isNaN(parseInt(paddingTop, 10)) ? Math.ceil(parseInt(paddingTop, 10)) : 0;
          paddingBottom = isNaN(parseInt(paddingBottom, 10)) ? Math.ceil(parseInt(paddingBottom, 10)) : 0;
          marginTop = isNaN(parseInt(marginTop, 10)) ? Math.ceil(parseInt(marginTop, 10)) : 0;
          marginBottom = isNaN(parseInt(marginBottom, 10)) ? Math.ceil(parseInt(marginBottom, 10)) : 0;

          // if ((computedStyle.marginTop && computedStyle.marginTop !== 'auto')) {
          //   marginTop = isNaN(parseInt(computedStyle.marginTop, 10)) ? Math.ceil(parseInt(computedStyle.marginTop, 10)) : 0;
          // }
          // if ((computedStyle.marginTop && computedStyle.marginTop !== 'auto')) {
          //   marginBottom = isNaN(parseInt(computedStyle.marginBottom, 10)) ? Math.ceil(parseInt(computedStyle.marginBottom, 10)) : 0;
          // }
        }
      }
    }
    if (rect) {
      return { top, left, height, width, marginTop, marginBottom, paddingTop, paddingBottom };
    }
    return null;
  }

  getBorderForTableRow = (tableRow) => {
    const computedStyle = window.getComputedStyle(tableRow);
    let borderSum = 0;
    if (computedStyle.borderBottomWidth !== '0px' || computedStyle.borderBottomWidth !== '0' || computedStyle.borderBottomWidth !== 'auto') {
      borderSum += parseInt(computedStyle.borderBottomWidth.replace('px', ''), 10);
    }
    if (computedStyle.borderTopWidth !== '0px' || computedStyle.borderTopWidth !== '0' || computedStyle.borderTopWidth !== 'auto') {
      borderSum += parseInt(computedStyle.borderTopWidth.replace('px', ''), 10);
    }
    return Math.ceil(borderSum);
  }

  handleTableObjectRendering = (tbl) => {
    const table = tbl;
    // let currentHeight = this.offset(document.querySelector('#divPrint .cTable tbody')).top;
    const tableDataRows = table.querySelectorAll('tr');
    if (tableDataRows && tableDataRows.length) {
      const tdCount = table.querySelector('tbody tr').querySelectorAll('td').length; // get the length of columns
      let spacerInserted = 0;
      tableDataRows.forEach((dataRow, index) => {
        let dataRowHeight = 0;
        const dataRowOffset = this.offset(dataRow);
        dataRowHeight = (dataRowOffset.top + dataRowOffset.height + dataRowOffset.paddingBottom + dataRowOffset.paddingTop + this.pageMargin);
        if (dataRowHeight > this.totalPageHeight) {
          // Insert blank row
          const rowHeight = (this.totalPageHeight - this.currentHeight);
          const row = table.insertRow((spacerInserted + index));
          spacerInserted += 1;
          row.setAttribute('border', 'none');
          row.setAttribute('class', 'dummyRow');
          row.setAttribute('style', 'height:' + (rowHeight + this.pageMargin) + 'px !important;');
          // row.setAttribute('style', 'height:' + (rowHeight + this.pageMargin) + 'px !important;border: 1px solid red;');

          const cell1 = row.insertCell(0);
          cell1.innerText = ' ';
          cell1.setAttribute('align', 'center');
          cell1.setAttribute('colspan', tdCount);
          cell1.setAttribute('style', 'padding: 0;');
          this.setCurrentHeight(this.totalPageHeight + dataRowOffset.height);
          this.setTotalHeight(this.pageHeight + this.totalPageHeight); //  + this.offset(dataRow).height
        } else {
          this.setCurrentHeight(dataRowHeight); // + this.getBorderForTableRow(dataRow);
        }
      });
    }
  }

  handleLargeTextBlock = (el, pendingHeight) => {
    if (el.nodeValue) {
      let heightToCheck = pendingHeight || this.pageHeight;
      // wrap text in element so we can get the client bounding rect for text
      let wrapperSection = document.createElement('span');
      wrapperSection.setAttribute('class', 'dummySection');
      el.parentNode.insertBefore(wrapperSection, el);
      // Check the height and create multiple divs based on height available / total height
      const words = el.nodeValue.split(' ');
      let randomWordCount = 0;
      let wrapperOldHeight = 0;
      while (randomWordCount < words.length) {
        if (words[randomWordCount]) {
          wrapperSection.append(words[randomWordCount] + ' ');
          const wrapperOffset = this.offset(wrapperSection);
          const wrapperBottom = wrapperOffset.height;
          if (wrapperBottom < heightToCheck) { // word fits in current line and is under specified asset
            this.setCurrentHeight(wrapperBottom);
            if (wrapperOldHeight !== wrapperBottom) { // word going beyond available asset
              wrapperOldHeight = wrapperBottom;
            }
          } else {
            // remove last inserted word from warpper and save it for return
            const temp = wrapperSection.innerText.split(' ');
            temp.pop();
            wrapperSection.innerText = temp.join(' ');
            // returnElements.push(wrapperSection);
            // Add spacer of 10px to push next section to new line
            this.addSpacer(wrapperSection, this.pageMargin + 'px', this.totalPageHeight + 'px');
            wrapperSection = null;
            // create new element
            wrapperSection = document.createElement('span');
            wrapperSection.append(words[randomWordCount] + ' ');
            el.parentNode.insertBefore(wrapperSection, el);
            // set global variables
            this.setCurrentHeight(this.totalPageHeight);
            this.setTotalHeight(this.totalPageHeight + this.pageHeight); // add new page
            heightToCheck = this.pageHeight;
          }
        }
        // check the height of wrapperSection
        randomWordCount += 1;
        // check the size of wrappered div, add further text if wrapper height < (pageHeight - 50px)
      }
      el.remove();
    }
  }

  addWrapper = (elem, tag = 'span') => {
    const wrapperSection = document.createElement(tag);
    wrapperSection.setAttribute('class', 'dummySection');
    elem.parentNode.insertBefore(wrapperSection, elem);
    wrapperSection.append(elem);
    return wrapperSection;
  }

  addSpacer = (elem, height, top = null, prepend = false, tag = 'section') => {
    const spacer = document.createElement(tag);
    spacer.setAttribute('class', 'spacer');
    spacer.setAttribute('width', '100%');
    if (top) {
      spacer.setAttribute('top', top);
    }
    spacer.setAttribute('style', 'height: ' + height + ';');
    // spacer.setAttribute('style', 'height: ' + height + ';border: 1px solid green;');
    spacer.innerHtml = '<i class="empty" />';
    if (prepend) {
      elem.prepend(spacer);
    } else {
      spacer.setAttribute('data-identifier', 'append');
      // elem.nextSibling.insertBefore(spacer, elem.nextSibling);
      elem.insertAdjacentElement('afterend', spacer);
    }
  }
  moveToNewPage = (el, childOffset) => {   // eslint-disable-line no-unused-vars
    // insert devider to move conyent to new Page
    // const spaceHeight = ((this.totalPageHeight + this.pageMargin) - (this.currentHeight));
    const spaceHeight = (this.totalPageHeight - this.currentHeight);
    // const spaceHeight = (this.totalPageHeight - (this.currentHeight + childOffset.marginTop));

    // this.addSpacer(el, (spaceHeight + this.pageMargin) + 'px', this.totalPageHeight, true);
    this.addSpacer(el, (spaceHeight) + 'px', null, true);

    // this.setCurrentHeight(this.totalPageHeight + this.pageMargin);
    this.setCurrentHeight(this.totalPageHeight);
    this.setTotalHeight(this.pageHeight + this.totalPageHeight);
    // this.addSpacer(el, '10px', (this.totalPageHeight + 10 + 'px'), false);
  }

  setCurrentHeight = (height) => {
    if (height && height > this.currentHeight) {
      this.currentHeight = height;
    }
  }

  setTotalHeight = (height) => {
    this.totalPageHeight = height;
    this.heightToCheck = this.totalPageHeight - this.pageMargin;
  }

  isActualTextNode = (elemValue) => {
    // const letters = new RegExp(/^[0-9a-zA-Z ]+$/);
    const valLength = elemValue.replace(/ /g, '').length;
    return valLength > 0;
  }

  getPreviousElementMarginForText = textElem =>
    this.offset(textElem.previousSibling)

  getChildNodes = el =>
    el.childNodes

  getElementBottom = (e1) => {
    const elementOffset = this.offset(e1);
    let bottom = 0;
    // let marginBottom = (elementOffset.marginBottom && elementOffset.marginBottom !== 'auto') ? elementOffset.marginBottom : 0;
    if (elementOffset) {
      bottom = elementOffset.top + elementOffset.height + elementOffset.marginBottom; // + elementOffset.paddingBottom + elementOffset.paddingTop; // + elementOffset.marginBottom;
    }
    return Math.ceil(bottom);
  }

  getChildHeight = (el) => {
    const childNodes = this.getChildNodes(el);
    let childHeight = 0;
    childNodes.forEach((child) => {
      const childOffset = this.offset(child);
      if (childOffset.height > childHeight) {
        childHeight = childOffset.height;
      }
      if (child.nodeType === 1 && child.hasChildNodes) {
        const tempCHildHeight = this.getChildHeight(child);
        if (tempCHildHeight > childHeight) {
          childHeight = tempCHildHeight;
        }
      }
    });
    return childHeight;
  }

  splitHTMLForPrintToPDF = (el) => {
    // decide if node is textNode or HTML
    const hasChild = el.hasChildNodes() && el.childElementCount;
    if (hasChild) { // we are still dealing with HTML
      const childNodes = this.getChildNodes(el);
      const childCount = el.childElementCount;
      childNodes.forEach((child, index) => { // iterate through each child
        const childOffset = this.offset(child);

        if (child.classList && child.classList.contains('dummyPageBreak')) {
          this.moveToNewPage(child, childOffset);
        }
        // TODO: need to check the pre-offset scenario and remove if not required
        const preOffset = (childCount > 1 && index > 0) ? this.getPreviousElementMarginForText(childNodes[index - 1]) : null;
        let childBottom = this.getElementBottom(child);
        const childNodeType = child.nodeType;
        let preMargin = 0;
        let textElem = null;
        // If node type is text first wrap it within section
        if (childNodeType === 3) {  // Text node
          textElem = this.addWrapper(child);
          childBottom = this.getElementBottom(textElem);
          if (preOffset && preOffset.marginBottom && preOffset.marginBottom !== 'auto') {
            preMargin = Math.ceil(preOffset.marginBottom) + Math.ceil(preOffset.marginTop);
          }
        }

        // Logic for split begins
        // if (childNodeType === 1 && childOffset.height === 0 && child.childNodes && child.childNodes.length > 0) {
        if (child.classList && child.classList.contains('dummyPageBreak')) {
        } else if (childNodeType === 1 && child.childNodes && child.childNodes.length > 0 && child.classList && child.classList.length === 0) {
          this.splitHTMLForPrintToPDF(child);
        } else if (child.classList && child.classList.length && (child.classList.contains('divTR') || child.classList.contains('mainContent')) && childBottom > this.heightToCheck) {
          const spaceHeight = (this.totalPageHeight - (this.currentHeight));
          this.addSpacer(child, (spaceHeight + this.pageMargin) + 'px', null, true);
          this.setCurrentHeight(this.totalPageHeight);
          this.setTotalHeight(this.pageHeight + this.totalPageHeight);
        } else if (childBottom <= this.heightToCheck) {
          this.setCurrentHeight(childBottom);
        } else {
          let remainingHeight = 0;
          if (childNodeType === 3 && this.isActualTextNode(child.nodeValue)) {
            const textElemBottom = this.getElementBottom(textElem) + preMargin;
            if (textElemBottom <= this.heightToCheck) {
              this.setCurrentHeight(textElemBottom);
            } else {
              remainingHeight = (this.totalPageHeight - (this.currentHeight + this.pageMargin));
              if (remainingHeight > 0) {
                this.handleLargeTextBlock(child, remainingHeight);
              }
              // TODO: check need of appending devider
            }
          } else if (childNodeType === 1) { // proper scementic HTML elements like DIV, P, TABLE, HEADER, FOOTER, SECTION..... etc.....
            if (child.nodeName.toLowerCase() === 'table') {
              this.handleTableObjectRendering(child);
              // } else if (childOffset.height <= this.pageMargin) {
              //   // insert special devider
              //   const spaceHeight = (this.totalPageHeight - (this.currentHeight));
              //   this.addSpacer(child, (spaceHeight + this.pageMargin) + 'px', null, true);
              //   this.setCurrentHeight(this.totalPageHeight);
              //   this.setTotalHeight(this.pageHeight + this.totalPageHeight);
            } else if (child.hasChildNodes() && child.childElementCount) { // container elements usually has height as 0 but do contain lot of content
              this.splitHTMLForPrintToPDF(child);
            } else {
              // insert devider
              let spaceHeight = 0;
              spaceHeight = (this.totalPageHeight - this.currentHeight);
              if (child.outerHTML.toLocaleLowerCase() === '<br>') {
                this.addSpacer(child, (spaceHeight + this.pageMargin) + 'px', null, false);
              } else {
                this.addSpacer(child, (spaceHeight + this.pageMargin) + 'px', null, true);
              }
              this.setCurrentHeight(this.totalPageHeight);
              this.setTotalHeight(this.pageHeight + this.totalPageHeight);
            }
          }
        }
      });
    } else { // logic to split large chunk of text, assuming if html is not having any child nodes it is text
      this.setCurrentHeight(this.getElementBottom(el));
      // this.handleLargeTextBlock(el, (this.totalPageHeight - this.currentHeight));
    }
  }

  render() {
    this.brandLogo = commonUtil.getBrandLogoPathforPDF();
    const { printClass } = this.props;
    let settingCSS = {};
    if (pageNameTableOrg === this.props.pageName && this.props.orientation === 'l') {
      // if (channel === 'web') {
      settingCSS = { width: 'auto', maxWidth: '1366px', minWidth: '1240px' };
      // }
    }
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
    let printingDate = commonUtil.formatDate(this.props.printingDate, 'dd/mm/yyyy') || `${day}/${month}/${year}`;

    const mesa_de_regalos_logo = commonUtil.getImageMeta().mesaDeRegalosLogo;

    return (
      <React.Fragment>
        {/* <ApplyCSS pageName={this.props.pageName} /> */}
        <div id="divPrint" className={'printPage ' + (printClass || 'toPrint')} style={settingCSS}>
          <div className="row pdfclass">
            <div className="col-xs-6 col-sm-6 pdf-header-imgs">
              <img src={this.brandLogo} className='brand-img-logo' />
              <img className="pdf-mesalogo" src={mesa_de_regalos_logo} />
            </div>
            <div className="col-xs-6 col-sm-6 text-right mt-15">
              <div className="mt-15">{printingDate}</div>
            </div>
          </div>
          <div>
            {/* this.props.downloadContent */}
            {this.props.children}
          </div>
        </div>
      </React.Fragment>
    );
  }
}
export default DownloadPDFWithoutPreview;